import { GridColDef } from '@mui/x-data-grid';
import Table from '../custom/Table';
import Title from '../custom/Title';
import DynamicForm from '../forms/DynamicForm';
import { INBOUND_BLOTTER_FIELDS, SEARCH_INBOUND_BLOTTER_FIELDS } from '../../Models/BlotterTables';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { PATHS } from '../../utils/constant';


export const InboundBlotter = () => {

    const config = SEARCH_INBOUND_BLOTTER_FIELDS

    const getInboundBlotterColumns = (): GridColDef<any>[] => {
        let minWidth = 100
        return INBOUND_BLOTTER_FIELDS.map(inboundField => {
            switch (inboundField.id) {
                case "customerName":
                    minWidth = 150
                    break;
                case "customerReference":
                    minWidth = 150
                    break;
                case "gtTransactionType":
                    minWidth = 150
                    break;
                case "transactionLocation":
                    minWidth = 160
                    break;
                default:
                    minWidth = 100
                    break;
            }

            return {
                field: inboundField.id,
                headerName: inboundField.label,
                minWidth
            }
        })
    }

    const InblotterRows = [{ id: 1 }]

    const submitHandler = (data: any): any => {
    }
    const navigate = useNavigate()

    return (
        <div style={{ padding: '0 10px' }}>
            <div style={{ borderBottom: '1px solid #d8d8d8' }}>
                <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Inbound Blotter</Title>
            </div>
            <div style={{ padding: '20px 0px' }}>
                <DynamicForm config={config} onSubmit={submitHandler} submitText='Search' onCancel={() => { }} cancelText='Clear Filter' />
            </div>
            <Table columns={getInboundBlotterColumns()} rows={InblotterRows} />
            <div style={{ paddingTop: "30px" }}>
                <Button variant='contained' type='submit' onClick={()=> navigate(PATHS.CREATE_TRANSACTION)}>{'Create Inbound'}</Button>
            </div>
        </div>
    )
}
